var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTerrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_terrain"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bigg",
    opacity: 0.5,
    d: "M14 20H22L13.7595 6.42739C13.5984 6.16203 13.3104 6 13 6C12.6896 6 12.4016 6.16203 12.2405 6.42739L8.90909 11.9144L14 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7595 6.42739L20.7857 18H22C22.5523 18 23 18.4477 23 19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19C1 18.4477 1.44772 18 2 18H3.25926L7.48906 11.2821C7.5996 11.1065 7.79254 11 8 11C8.20746 11 8.4004 11.1065 8.51094 11.2821L8.9091 11.9144L12.2405 6.42739C12.4016 6.16203 12.6896 6 13 6C13.3105 6 13.5984 6.16203 13.7595 6.42739ZM5.62267 18H10.3773L8 14.2242L5.62267 18ZM12.7408 18H18.446L13 9.0302L10.1003 13.8063L12.7408 18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTerrain);
export default __webpack_public_path__ + "static/media/ic_action_terrain.fe3f98b0662e0e88329e8885e82e4af4.svg";
export { ForwardRef as ReactComponent };